import { PricingTiers } from "../home/Billing";
import classNames from "./PricingPage.module.css";

const PricingPage = () => {
  return (
    <div className={classNames.PricingPage}>
      <h1>Pricing & plans</h1>
      <div className={classNames.Tiers}>
        <PricingTiers />
      </div>
    </div>
  );
};

export default PricingPage;
